import { render, staticRenderFns } from "./ControlloAlloggiTabelloneEsportaView.vue?vue&type=template&id=138abf65&"
import script from "./ControlloAlloggiTabelloneEsportaView.vue?vue&type=script&lang=ts&"
export * from "./ControlloAlloggiTabelloneEsportaView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports